import { ExpenseRequest } from "../../../types/types";
import { api } from "../api";

const expenseUpdateByVehicle = async (
    token: string,
    id: number,
    model: ExpenseRequest,
) => {
    return api.put(`/expenses/${id}`, model, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
};

export default expenseUpdateByVehicle;
